module.exports = __webpack_public_path__ + "img/QR-code-and-Barcode-Scanning.291453d0.svg";